import { render, staticRenderFns } from "./EditSasvEmailTemplateModal.vue?vue&type=template&id=0949a8a2"
import script from "./EditSasvEmailTemplateModal.vue?vue&type=script&lang=js"
export * from "./EditSasvEmailTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./EditSasvEmailTemplateModal.vue?vue&type=style&index=0&id=0949a8a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports